import { render, staticRenderFns } from "./PaymentsLoadingState.vue?vue&type=template&id=1ef855b8&scoped=true&"
import script from "./PaymentsLoadingState.vue?vue&type=script&lang=js&"
export * from "./PaymentsLoadingState.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsLoadingState.vue?vue&type=style&index=0&id=1ef855b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef855b8",
  null
  
)

export default component.exports